import { metabaseURL } from '@/config/urls'
import { ifAuthenticated } from '@/router/before'

export const profileRouteNames = {
  ProfileRoute: 'ProfileRoute',
  MetabaseRoute: 'MetabaseRoute'
}
const rn = profileRouteNames

export const profileRouteURLs = {
  [rn.ProfileRoute]: '/profile',
  [rn.MetabaseRoute]: '/metabase-redirect'
}

export const profilePages = [
  {
    path: profileRouteURLs[rn.ProfileRoute],
    name: rn.ProfileRoute,
    meta: {
      sidebar: {
        icon: ['fa', 'user'],
        isDisplay: true
      },
      navbar: {
        group: 'Профиль',
        displayName: 'Страница профиля'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "ProfileRoute" */ '@/views/profile/ProfileRoute.vue'
      )
  },
  {
    path: profileRouteURLs[rn.MetabaseRoute],
    name: rn.MetabaseRoute,
    meta: {
      sidebar: {
        icon: ['fa', 'database'],
        isDisplay: true
      },
      navbar: {
        group: 'Профиль',
        displayName: 'Metabase'
      }
    },
    beforeEnter: () => {
      window.location.href = metabaseURL
    }
  }
]
